// var urlBase = process.env.NEXT_PUBLIC_BASE_URL;

import config from '@/localconfig';
const urlBase = config.BASE_URL;

const postContact = (body) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }
    return fetch(urlBase +'/api/v1/contacts', requestOptions)
}

export{
    postContact
}